<template>
	<button
		:class="[
			'relative btn p-3 bg-white w-full text-primary-superdark text-start rounded border border-gray flex items-center',
			isCorrupt
				? 'cursor-not-allowed'
				: 'hover:bg-gray-light focus:bg-gray-light'
		]"
		:title="'media_1445_10022026.jpeg'"
		@click.prevent="downloadMedia()"
	>
		<aside v-if="icon" class="shrink-0">
			<div
				:class="[
					'text-center grid place-items-center rounded border p-3',
					isCorrupt
						? 'text-red border-red bg-red-light'
						: 'text-primary border-primary bg-primary-light'
				]"
			>
				<component :is="icon" class="size-6"></component>
			</div>
		</aside>
		<div class="ps-3 min-w-px">
			<p class="truncate">{{ props.attachment.filename }}</p>
			<p
				:class="[
					'text-sm font-light',
					isCorrupt ? 'text-red' : 'text-gray-dark'
				]"
			>
				{{ fileTypeDescription }}
			</p>
		</div>

		<!-- Loading -->
		<Transition name="fade">
			<div
				v-if="isDownloading"
				class="absolute inset-0 grid place-items-center bg-white/70"
			>
				<Spinner class="size-8 text-primary"></Spinner>
			</div>
		</Transition>
	</button>
</template>

<script setup lang="ts">
import File from '@/assets/icons/file.svg'
import Spinner from '@/assets/icons/spinner.svg'
import DismissCircleFill from '@/assets/icons/dismiss-circle-fill.svg'
import { ref, computed } from 'vue'
import type { Props } from '@/types/Media'
import { useChatStore } from '@/stores/chatStore'
const chatStore = useChatStore()

const props = defineProps<Props>()

const isCorrupt = computed<boolean>(() => {
	return ['Failed', 'Infected'].includes(props.attachment.uploadState)
})

/**
 * downloads media
 */
const isDownloading = computed<boolean>(() => {
	return chatStore.downloadingAttachmentsFileIdents.has(
		props.attachment.fileIdent
	)
})
const canDownload = computed<boolean>(() => {
	if (props.attachment.uploadState !== 'Received') {
		return false
	}

	return true
})
const downloadMedia = async () => {
	if (isDownloading.value || !canDownload.value) return

	chatStore.requestDownloadAttachment(props.attachment.fileIdent)
}

/**
 * returns icon based by file type
 */
const icon = computed(() => {
	if (!canDownload.value && !isCorrupt.value) {
		return Spinner
	}

	if (isCorrupt.value) {
		return DismissCircleFill
	}

	return File
})

const fileTypeDescription = computed(() => {
	if (isCorrupt.value) {
		return 'Soubor se nepodařilo nahrát'
	}

	switch (props.attachment.contentTypeCategory) {
		case 'Document':
			return 'Dokument'
		case 'Image':
			return 'Obrázek'
		case 'Video':
			return 'Video'
		default:
			return 'Soubor'
	}
})
</script>

<style scoped lang="postcss"></style>
